import { type UseQueryResult, useQuery } from 'react-query';
import { CompantTypeService } from '@wealthlane/api-services/wealthlane-identity-service';
import {
  BrokerService,
  CompanyTransferAgentService,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetTransferAgentCurrent = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string | null | undefined;
      value: string | undefined;
    }>
  | undefined,
  unknown
> => {
  const transferAgentCurrent = useQuery(
    ['getTransferAgentCurrent'],
    async () => {
      return await handleRequest(
        CompanyTransferAgentService.getApiCustomerCompanyTransferAgentCurrent()
      );
    },
    {
      select(data) {
        return [
          {
            label: data.name,
            value: data.id,
          },
        ];
      },
    }
  );

  return transferAgentCurrent;
};

export default useGetTransferAgentCurrent;
